import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { api, useApp } from "@/context/AppContext";

export const Footer = () => {
  const { t } = useApp();
  const [social, setSocial] = useState(null);
  useEffect(() => { api.get("/social").then((r) => setSocial(r.data)).catch(() => {}); }, []);
  const fb = social?.facebook_url || "https://www.facebook.com/ZendaHiking/";
  const ig = social?.instagram_url || "https://www.instagram.com/zendahiking/";
  return (
    <footer className="bg-[#6E7E56] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-[220px_1fr]">
        <div>
          <img src="/logo-zenda.png" alt="Zenda Hiking" className="h-24 w-24 object-contain mb-2" />
          <p className="font-heading text-lg tracking-[0.18em] uppercase">Zenda Hiking</p>
          <p className="text-sm text-white/70 mt-1">{t.footer.tagline}</p>
        </div>
        <div className="md:text-right">
          <div className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end text-lg">
            <Link to="/" className="hover:text-[#F0C674] transition-colors duration-300">{t.nav.home}</Link>
            <Link to="/tours" className="hover:text-[#F0C674] transition-colors duration-300">{t.nav.tours}</Link>
            <Link to="/calendario" className="hover:text-[#F0C674] transition-colors duration-300">{t.nav.calendar}</Link>
            <Link to="/principiantes" className="hover:text-[#F0C674] transition-colors duration-300">{t.nav.beginners}</Link>
            <Link to="/gestionar-reserva" data-testid="footer-manage-link" className="hover:text-[#F0C674] transition-colors duration-300">Gestionar reserva</Link>
            <Link to="/regalo" data-testid="footer-gift-link" className="hover:text-[#F0C674] transition-colors duration-300">Regala una montaña</Link>
            <Link to="/membresias" data-testid="footer-memberships-link" className="hover:text-[#F0C674] transition-colors duration-300">Membresías</Link>
          </div>
          <div className="flex gap-3 mt-8 md:justify-end">
            <a href="https://wa.me/525648217858" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
              className="h-9 w-9 rounded-full bg-white/15 flex items-center justify-center hover:bg-white/30 transition-colors duration-300">
              <MessageCircle className="h-4 w-4" />
            </a>
            {[{ Icon: Facebook, url: fb, id: "facebook" }, { Icon: Instagram, url: ig, id: "instagram" }].map(({ Icon, url, id }) => (
              <a key={id} href={url} target="_blank" rel="noopener noreferrer" data-testid={`footer-${id}-link`}
                aria-label={id}
                className="h-9 w-9 rounded-full bg-white/15 flex items-center justify-center hover:bg-white/30 transition-colors duration-300">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
            <span className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-sm text-white/70">
              <Link to="/aviso-de-privacidad" data-testid="footer-privacy-link"
                className="hover:text-[#F0C674] transition-colors duration-300">{t.footer.privacy}</Link>
              <Link to="/terminos-y-condiciones" data-testid="footer-terms-link"
                className="hover:text-[#F0C674] transition-colors duration-300">{t.footer.terms}</Link>
              <Link to="/politicas-de-cancelacion" data-testid="footer-policies-link"
                className="hover:text-[#F0C674] transition-colors duration-300">{t.footer.cancel}</Link>
            </span>
          <p className="text-sm text-white/60 mt-3">©2026 Zenda Hiking. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
